import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Signal,
  ViewEncapsulation,
  booleanAttribute,
  effect,
  inject,
  input
} from '@angular/core';
import { MatRipple, MatRippleModule } from '@angular/material/core';
import { ShevronStartIcon } from "assets/icons/shevron-start/shevron-start";
import { ArrowDownIcon } from "assets/icons/arrow-down/arrow-down";

@Component({
  selector: 'button[shButton], a[shButton], [shButton]',
  templateUrl: 'button.component.html',
  styleUrls: ['button.component.scss'],
  exportAs: 'shButton',
  standalone: true,
  imports: [MatRippleModule, ShevronStartIcon, ArrowDownIcon],
  host: {
    matRipple: '',
    class: 'sh-button',
    '[attr.color]': 'color()',
    '[ariaDisabled]': 'disabled()',
    '[attr.disabled]': 'disabled() || null'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  hostDirectives: [MatRipple]
})
export class ShebaButtonComponent {
  elementRef = inject<ElementRef>(ElementRef);
  disabled = input(false, { transform: booleanAttribute });

  bold = input(false, {
    transform: booleanAttribute
  });
  color = input<'green' | 'blue' | 'black' | 'pink' | 'white' | 'lightgreen' | 'grey'>();
  outline = input(false, {
    transform: booleanAttribute
  });
  full = input(false, {
    transform: booleanAttribute
  });
  big = input(false, {
    transform: booleanAttribute
  });
  iconEnd = input(false, {
    transform: booleanAttribute
  });
  iconStart = input(false, {
    transform: booleanAttribute
  });
  iconDown = input(false, {
    transform: booleanAttribute
  });

  constructor() {
    setMatRippleDisabled(this.disabled);
    effect(() => {
      if (this.color()) {
        this.elementRef.nativeElement.setAttribute('color', this.color());
      }
    });
  }
}

function setMatRippleDisabled(disabled: Signal<boolean>) {
  const ripple = inject(MatRipple);
  effect(() => {
    disabled() ? (ripple.disabled = true) : (ripple.disabled = false);
  });

  return disabled;
}
